/**
 * Core API — social graph (follow, friend requests, block).
 */

export const CORE_MUTATION_FOLLOW_USER = `
  mutation CoreFollowUser($username: String!) {
    followUser(username: $username) {
      ok
      error
    }
  }
`;

export const CORE_MUTATION_UNFOLLOW_USER = `
  mutation CoreUnfollowUser($username: String!) {
    unfollowUser(username: $username) {
      ok
      error
    }
  }
`;

export const CORE_MUTATION_SEND_FRIEND_REQUEST = `
  mutation CoreSendFriendRequest($username: String!) {
    sendFriendRequest(username: $username) {
      ok
      error
    }
  }
`;

export const CORE_MUTATION_REJECT_FRIEND_REQUEST = `
  mutation CoreRejectFriendRequest($requestId: Int!) {
    rejectFriendRequest(requestId: $requestId) {
      ok
      error
    }
  }
`;

export const CORE_MUTATION_ACCEPT_FRIEND_REQUEST = `
  mutation CoreAcceptFriendRequest($requestId: Int!) {
    acceptFriendRequest(requestId: $requestId) {
      ok
      error
    }
  }
`;

export const CORE_MUTATION_CANCEL_FRIEND_REQUEST = `
  mutation CoreCancelFriendRequest($requestId: Int!) {
    cancelFriendRequest(requestId: $requestId) {
      ok
      error
    }
  }
`;

export const CORE_MUTATION_CANCEL_FRIEND_REQUEST_TO_USER = `
  mutation CancelFriendRequestToUser($username: String!) {
    cancelFriendRequestToUser(username: $username) {
      ok
      error
      friendRequest {
        id
        status
        sender {
          username
        }
        receiver {
          username
        }
      }
    }
  }
`;

export const CORE_MUTATION_REMOVE_FRIEND = `
  mutation CoreRemoveFriend($username: String!) {
    removeFriend(username: $username) {
      ok
      error
    }
  }
`;

export const CORE_MUTATION_BLOCK_USER = `
  mutation CoreBlockUser($username: String!) {
    blockUser(username: $username) {
      ok
      error
    }
  }
`;

export const CORE_MUTATION_UNBLOCK_USER = `
  mutation CoreUnblockUser($username: String!) {
    unblockUser(username: $username) {
      ok
      error
      changed
    }
  }
`;

export const CORE_MUTATION_VOUCH_FOR_USER = `
  mutation CoreVouchForUser($username: String!) {
    vouchForUser(username: $username) {
      ok
      error
      vouchCount
      isVerified
    }
  }
`;
